/**
 * Login Route
 * Public route for user authentication with backend OAuth2 JWT APIs
 */

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { LoginPage } from '../pages/Auth/LoginPage';
import { requireGuest } from '../router/guards';

const LoginRouteComponent = () => {
  const navigate = useNavigate();

  return (
    <LoginPage
      onForgotPassword={(email) => navigate({ to: '/forgot-password', search: { email } as never })}
      onSignUp={() => navigate({ to: '/signup' })}
    />
  );
};

// Create login route with guest guard
export const Route = createFileRoute('/login')({
  beforeLoad: requireGuest,
  component: LoginRouteComponent,
});
